import React from "react";

export const NotProvided = ({ text }: { text?: string }) => (
  <span className="text-muted">{text || "not provided"}</span>
);

export default NotProvided;
